import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';
import './Footer.css';

function Footer() {
  // CQ-22: settings via context.
  const settings = useSettings();

  const s = (key, fallback = '') => settings[key] !== undefined ? settings[key] : fallback;

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">
              <img src="/images/asg-logo-white.webp" alt="ASG Shading" className="footer__logo-img" width="150" height="100" />
            </div>
            <p className="footer__tagline">Premium pergola systems, engineered for Australian living.</p>
            <p className="footer__abn">ABN 54 658 871 369</p>
          </div>

          {/* Column titles are h2: the footer is its own landmark and these are
              its top-level sections. h4 skipped a level on pages whose last
              heading was the h1 (sign-in, checkout, colours), which trips the
              heading-order check in every accessibility and SEO audit. */}
          <div className="footer__cols">
            <div className="footer__col">
              <h2 className="footer__col-title">Navigate</h2>
              <Link to="/" className="footer__link">Home</Link>
              <Link to="/products" className="footer__link">Products</Link>
              <Link to="/gallery" className="footer__link">Gallery</Link>
              <Link to="/blog" className="footer__link">Blog</Link>
              <Link to="/contact" className="footer__link">Contact</Link>
              <Link to="/about" className="footer__link">About</Link>
            </div>

            <div className="footer__col">
              <h2 className="footer__col-title">Products</h2>
              <Link to="/products/pergola-175" className="footer__link">Louvered Pergolas</Link>
              <Link to="/products/pergola-163" className="footer__link">Compact Pergolas</Link>
              <Link to="/products/pergola-180-retractable" className="footer__link">Retractable Roofs</Link>
              {/* Free posted samples were discontinued; /samples is gone and
                  301-redirects to /colours, which is the on-site replacement. */}
              <Link to="/products" className="footer__link">All Products</Link>
            </div>

            <div className="footer__col">
              <h2 className="footer__col-title">Contact</h2>
              <a href="tel:+61422439499" className="footer__link">
                +61 422 439 499
              </a>
              <a href="mailto:info@asgshading.com.au" className="footer__link">
                info@asgshading.com.au
              </a>
              <span className="footer__link footer__link--static">Hoppers Crossing, VIC 3029</span>
            </div>
          </div>
        </div>

        <p className="footer__service-area">
          Based in Hoppers Crossing. Free delivery to most of Melbourne (including Werribee, Point Cook, Williamstown, Footscray, Sunshine, Dandenong and Epping); a flat $150 to outer suburbs such as Geelong, Frankston, Pakenham and Berwick; and freight quoted elsewhere, including Cranbourne and interstate. <Link to="/delivery" className="footer__link">See delivery zones</Link>.
        </p>

        <div className="footer__bottom">
          <p className="footer__copy">&copy; {new Date().getFullYear()} ASG Shading. All rights reserved.</p>
          <div className="footer__bottom-links">
            <Link to="/privacy" className="footer__bottom-link">Privacy</Link>
            <Link to="/terms" className="footer__bottom-link">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
